import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "../../lib/api";
import { Roundel } from "../../components/brand/icons";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-offwhite px-5" data-testid="forgot-password-page">
      <div className="w-full max-w-md border border-charcoal p-8 lg:p-10">
        <Roundel className="h-16 w-16" />
        <h1 className="h-condensed mt-6 text-3xl">Reset password</h1>
        {sent ? (
          <p className="body-text mt-6 text-sm" data-testid="forgot-success">
            If an account exists for that email, a reset link is on its way. It works for one hour.
          </p>
        ) : (
          <form onSubmit={onSubmit} className="mt-6 space-y-5">
            <div>
              <label htmlFor="forgot-email" className="eyebrow mb-2 block text-[0.65rem]">Email</label>
              <input id="forgot-email" data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full border border-charcoal bg-transparent px-3 py-2.5 text-sm outline-none focus:ring-1 focus:ring-charcoal" />
            </div>
            {error && <p className="text-sm" role="alert" data-testid="forgot-error">{error}</p>}
            <button type="submit" disabled={busy} className="link-arrow text-xs disabled:opacity-50" data-testid="forgot-submit">
              {busy ? "Sending…" : "Send reset link"}
            </button>
          </form>
        )}
        <Link to="/admin/login" className="link-arrow mt-8 inline-block text-xs" data-testid="forgot-back-link">
          Back to sign in
        </Link>
      </div>
    </div>
  );
}
